export default {
  "ORDER_WAIT_SHIP": "Pendiente de envío",
  "Men fashion": "Ropa de hombre",
  "MyAccount_MyProfile_label_First": "Nombre",
  "MyAccount_MyShippingDetails_Phone": "Número de teléfono",
  "Page_not_found_message1": "Lo siento, no se pudo encontrar la página",
  "Help": "Ayuda",
  "Sign in": "Iniciar sesión",
  "Register": "Registrarse",
  "Category_sorting_Item": "Seleccionar forma de ordenamiento",
  "cart_clear": "Vaciar carrito",
  "Payment & Delivery": "Pago y envío",
  "Send my feedback": "Enviar mi opinión",
  "MyAccount_MyProfile_Save": "Guardar cambios",
  "Continue_billing": "Continuar con el pago",
  "Categories": "Categorías",
  "Read and understand": "He leído y entiendo",
  "Feel free to edit": "Edite cualquier detalle en cualquier momento para mantener la cuenta actualizada",
  "Select payment method": "Seleccionar método de pago",
  "Login_input_email": "Tu correo electrónico",
  "Login_input_first": "Nombre",
  "Account": "Cuenta",
  "Create_Time_Asc": "Creación ascendente",
  "concactus_label": "Opiniones o preguntas",
  "Order_Grade": "Calificación de orden",
  "wishlist_empty_desc": "Parece que aún no ha añadido nada a su cesta. ¡Comience a comprar ahora mismo!",
  "cartpreviewShipping_messageinfo": "Recibirá una confirmación y la fecha de entrega",
  "unsubscribe": "Puede darse de baja en cualquier momento",
  "prompt": "Indicación",
  "MyAccount_MyProfile_yinsi_message": "En Brand name, valoramos mucho la privacidad y estamos comprometidos a proteger los datos personales de los usuarios. Para obtener más información sobre cómo nos preocupamos y utilizamos su información personal, consulte nuestra política de privacidad.",
  "About us": "Acerca de nosotros",
  "or": "o",
  "MyAccount_Order_History_All": "Todas las órdenes",
  "What_We_Improve": "¿Qué podemos mejorar?",
  "MyAccount_ShippingDetails_title": "Detalles de envío",
  "MyAccount_Order_History_Tabs2": "Pendiente de pago",
  "Go_back_shopping": "Volver a comprar",
  "Product": "Producto",
  "Order summary": "Resumen del pedido",
  "payment_order_total": "Total de la orden",
  "Departments": "Declaración legal",
  "Download": "Descargar",
  "Your_Purchase_Order": "Su orden",
  "Your_Account": "Tu cuenta",
  "order_after_sales_list_null": "Actualmente no tiene órdenes postventa",
  "All_After_sales_orders": "Todas las órdenes postventa",
  "Filters": "Filtros",
  "search_results_not": "No encontramos resultados para la búsqueda seleccionada",
  "ORDER_WAIT_RECEIPT": "Pendiente de recibir",
  "ORDER_CLOSED": "Cerrado",
  "Order_View_details": "Detalle de la orden",
  "Subscribe_to_message": "Manténgase informado sobre próximas ventas y actividades. ¡Obtenga regalos y ofertas especiales!",
  "TaxFee": "Impuestos y tarifas",
  "Apply": "Aplicar",
  "Total_price": "Precio total",
  "Description": "Descripción",
  "Payment method": "Método de pago",
  "Back": "Volver",
  "Empty": "Parece que aún no ha añadido nada a su cesta. ¡Comience a comprar para llenarla!",
  "After_sales": "Postventa",
  "Instruction3": "Sí, lo sabemos.",
  "MyAccount_MyShippingDetails_Last": "Apellido",
  "MyAccount_MyShippingDetails_City": "Ciudad",
  "payment_order_discount": "Descuento en orden",
  "MyAccount_Order": "Detalle de orden",
  "ID_Name_Error": "Ingrese su nombre de identificación",
  "Kidswear": "Ropa para niños",
  "Share your look": "Comparte tu estilo",
  "Pay_Order": "Pagar orden",
  "Reset_Password": "Restablecer contraseña",
  "MyAccount_MyProfile_label2_pass1": "Contraseña actual",
  "Create_Time_Desc": "Creación descendente",
  "Items": "Artículos",
  "Login_Register": "Regístrate ahora",
  "Back to homepage": "Volver a la página de inicio",
  "switch_CNY": "Cambiar a yuanes",
  "Successful placed order": "Ha realizado su pedido con éxito. Puede comprobar el estado de su pedido utilizando nuestra función de estado de envío. Recibirá un correo electrónico de confirmación del pedido que incluirá los detalles de la orden y un enlace de seguimiento.",
  "MyAccount_MyProfile_yinsi_link": "política de privacidad",
  "Order_Date": "Fecha del pedido",
  "Allow order notifications": "Permitir notificaciones de orden",
  "MyAccount_MyProfile_Tab1": "Perfil personal",
  "MyAccount_ShippingDetails_changeTitle": "Cambiar dirección",
  "ID_Number": "Número de identificación",
  "Order_after_sales_message": "Detalle de la orden y órdenes postventa",
  "MyAccount_MyProfile_title2": "Si desea cambiar su contraseña de acceso a su cuenta, ingrese la siguiente información:",
  "Customer service": "Atención al cliente",
  "MyAccount_MyProfile_Update": "Actualizar contraseña",
  "choose_language": "Elige un idioma",
  "ORDER_REFUNDING": "Reembolso en proceso",
  "MyAccount_MyProfile_title1": "Edite cualquier detalle a continuación en cualquier momento para mantener su cuenta actualizada.",
  "ORDER_WAIT_RATE": "Pendiente de evaluación",
  "after_sales_refund_order": "Orden de reembolso postventa",
  "Who we are": "Quienes somos",
  "Women fashion": "Ropa de mujer",
  "Personal details": "Detalles personales",
  "Password": "Contraseña",
  "wishlist_empty_title": "Tu carrito de compras está vacío",
  "Repeat_Password": "Repetir contraseña",
  "cart_price": "Subtotal",
  "Sort_by": "Ordenar por",
  "Customer Reviews": "Opiniones de clientes",
  "Continue to shipping": "Continuar con el envío",
  "payment_make_order": "Realizar pedido",
  "save_order_review": "Enviar opinión",
  "Save_Password": "Guardar contraseña",
  "cart_empty_title": "Tu carrito de compras está vacío",
  "TopBar_help": "Ayuda y preguntas frecuentes",
  "colseCookie": "Entiendo",
  "Password_Changed": "Se ha cambiado la contraseña correctamente. Ahora puede volver a la página principal e iniciar sesión.",
  "Forgot Password Modal Email": "Tu correo electrónico de inicio de sesión:",
  "MyAccount_Personal": "Datos personales",
  "cartPreviewShipping": "Envío rápido",
  "ORDER_AFTER_SALE": "Asistencia",
  "Page_not_found": "Página no encontrada",
  "Find out more": "Saber más",
  "Log into your account": "Iniciar sesión en tu cuenta",
  "Details_and_status_orders": "Comprueba los detalles y estado de tus pedidos en la tienda online. También puedes cancelar el pedido o solicitar una devolución.",
  "Order_to_be_paid_message": "Pago pendiente",
  "Guarantee": "Garantía",
  "Sections that interest you": "Secciones de interés",
  "payment_post_tax": "Impuesto al envío",
  "ORDER_PAID": "Pagado",
  "concactus_label5": "Forma de tratamiento",
  "Item": "Artículo",
  "Go_back": "Volver",
  "more": "Más",
  "MyAccount": "Mi cuenta",
  "payment_agree_1": "Acepto",
  "total_items": "Total de artículos",
  "shopping_go": "Administrar direcciones de envío",
  "ID_Type": "Tipo de identificación",
  "after_sales_status": "Estado de la asistencia",
  "After_sales_apply": "Solicitar asistencia",
  "Login": "Iniciar sesión",
  "Quantity": "Cantidad",
  "payment_post_fee": "Tarifa de envío",
  "MyAccount_Log_out": "Cerrar sesión",
  "Subtotal": "Subtotal",
  "forgotPasswordConfirmation": "Gracias. Si se ha registrado con una {0} dirección de correo electrónico, encontrará un correo electrónico con un enlace para restablecer la contraseña en su bandeja de entrada.",
  "MyAccount_Order_History_Tabs1": "Mis pedidos",
  "concactus_img": "Cargar imagen",
  "Done": "Hecho",
  "Info after order": "Puede iniciar sesión en su cuenta con el correo electrónico y la contraseña que acaba de definir. En su cuenta, puede actualizar la información de su perfil, ver el historial de transacciones, editar las suscripciones de noticias, etc.",
  "MyAccoubnt_Set_newsletter": "Configure su suscripción a noticias y tendencias. Recibirá información sobre nuevos productos y tendencias de las secciones que elija cada semana.",
  "Shipping_method": "Método de envío",
  "after_sales_refund": "Importe devuelto",
  "After_sales_save": "Guardar información de la asistencia",
  "go_order_history": "Ver historial de pedidos",
  "contactus_message_placeholder": "Escribe tus opiniones o preguntas",
  "Login_Forgot_Password": "Si no recuerdas tu contraseña, puedes restablecerla.",
  "show_more": "Mostrar más",
  "MyAccount_MyProfile_label_email": "Tu correo electrónico",
  "MyAccount_MyProfile_label2_pass3": "Repetir contraseña",
  "Products": "Productos",
  "Review": "Comentario",
  "MyAccount_MyProfile_title3": "Tu dirección de correo electrónico actual es",
  "Category_found_Products": "Productos encontrados",
  "Match": "Combinación",
  "Read_all_reviews": "Leer todos los comentarios",
  "Commercial information": "Acepto recibir información comercial personalizada de Brand name por correo electrónico.",
  "Change password your account": "Si desea cambiar la contraseña de su cuenta de acceso, introduzca la siguiente información",
  "ID_Name": "Nombre en la identificación",
  "All": "Todo",
  "Instruction2": "¿Solo necesitas instrucciones de mantenimiento?",
  "MyAccount_ShippingDetails_Add": "Agregar una nueva dirección",
  "MyAccount_MyShippingDetails_Zip": "Código postal",
  "go_pay_order": "Pagar",
  "Thank_You_Inbox": "Si no recibió el correo electrónico, intente usar otra dirección de correo electrónico que pueda haber utilizado para registrarse.",
  "Subscribe": "Suscribirse",
  "confirm_subscription": "Confirmo la suscripción",
  "Login_input_Remember": "Recordar",
  "Add to compare": "Agregar para comparar",
  "Brand": "Marca",
  "Start_shopping": "Empezar a comprar",
  "Select shipping method": "Seleccionar método de envío",
  "address CN": "Si su dirección está en China, la moneda debe ser renminbi.",
  "MyAccount_MyShippingDetails_State": "Estado/Provincia",
  "Page_not_found_message2": "Vuelve o inténtalo de nuevo.",
  "Go_to_checkout": "Ir al proceso de pago",
  "See all results": "Ver todos los resultados",
  "search_results_inputnull": "Aún no has buscado productos.",
  "subscribeToNewsletterModalContent": "Al suscribirte, recibirás ofertas especiales e información personalizada de VSF por correo electrónico. En ningún momento vendemos ni distribuimos tu dirección de correo electrónico a terceros. Consulta nuestra {0}.",
  "Download all": "Descargar todo",
  "Login_input_last": "Apellido",
  "Amount": "Cantidad",
  "ORDER_WAIT_PAYMENT": "Pago pendiente",
  "Order_After_sales": "Servicio postventa de pedidos",
  "concattus_button": "Enviar",
  "Shipping_valid_required": "Este campo es obligatorio",
  "Price": "Precio",
  "ID_Type_Error": "Seleccione el tipo de documento de identidad",
  "Order_Status": "Estado del pedido",
  "Payment methods": "Formas de pago",
  "MyAccount_MyProfile_Tab2": "Cambiar contraseña",
  "Show on page": "Mostrar en la página",
  "Edit": "Editar",
  "Change": "Cambiar",
  "MyAccount_ShippingDetails_Update": "Actualizar dirección",
  "View": "Ver",
  "Privacy": "Privacidad",
  "Enter_promo_code": "Ingresar código de promoción",
  "Discount": "Descuento",
  "Delete": "Eliminar",
  "Wishlist": "Lista de deseos",
  "MyAccount_Order_History_Tabs3": "Devolver",
  "Go_To_Order_review": "Ir a la reseña del pedido",
  "Update personal data": "Actualizar datos personales",
  "payment_agree_2": "Términos y condiciones",
  "or fill the details below": "O complete los detalles a continuación",
  "Contact details updated": "Mantenga actualizada su dirección y detalles de contacto.",
  "Login_Create": "Crear cuenta",
  "Payment": "Pago",
  "Billing": "Facturación",
  "payment_insurance_tax": "Impuesto de seguro",
  "Size guide": "Guía de tallas",
  "Login_forgotten_password": "¿Olvidó su contraseña?",
  "Login_no_account": "¿No tiene una cuenta?",
  "Privacy_Policy": "Política de privacidad",
  "BootomCookieTitle": "Permisos de cookies",
  "Use your personal data": "En [nombre de la marca], nos importa mucho la privacidad y nos comprometemos a proteger los datos personales de nuestros usuarios. Para obtener más información sobre cómo cuidamos y utilizamos su información personal, consulte la",
  "Review my order": "Revisar mi pedido",
  "BootomCookieLink": "Aprender más",
  "hide": "Ocultar",
  "MyAccount_ShippingDetails_message_title": "Administre todas las direcciones de envío que desee (lugares de trabajo, domicilios...), de manera que no tenga que ingresar direcciones de envío manualmente en cada pedido.",
  "Purchase terms": "Términos de compra",
  "Billing_address": "Dirección de facturación",
  "Manage shipping addresses": "Administre todas las direcciones de envío que desee (lugares de trabajo, domicilios, etc.), de manera que no tenga que ingresar direcciones de envío manualmente en cada pedido.",
  "login_logbtn": "Iniciar sesión en la cuenta",
  "choose_currency": "Elige tu moneda",
  "ORDER_REFUNDED": "Reembolsado",
  "After_sales_form": "Completar el formulario de servicio postventa",
  "add_To_Wishlist": "Agregar a la lista de deseos",
  "search_results_inputnull2": "Empecemos ahora y te ayudaremos.",
  "Total": "Total",
  "Subscribe_to_newsletter": "Suscribirse al boletín",
  "Shipping_valid_Phone": "Introduzca un número de teléfono válido",
  "concactus_label3": "Título",
  "Manage billing addresses": "Administre todas las direcciones de facturación que desee (lugares de trabajo, domicilios...), de manera que no tenga que ingresar direcciones de facturación manualmente en cada pedido.",
  "Search_results_title": "Resultados de la búsqueda",
  "payment_order_payment": "Pago del pedido",
  "after_sales_Id": "ID de servicio postventa",
  "cart_title": "Mi carrito",
  "Order_Detail": "Detalles del pedido",
  "concactus_label2": "Enlace de tienda",
  "Shipping_valid_length_min": "Este campo debe tener al menos {min} caracteres",
  "Product suggestions": "Sugerencias de productos",
  "Return_home": "Volver al inicio",
  "Quality in the details": "Calidad en los detalles",
  "Continue_to_payment": "Continuar con el pago",
  "Feedback": "Su opinión es muy importante para nosotros. Por favor, díganos en qué podemos mejorar.",
  "Go back to shop": "Volver a la tienda",
  "Back_to_home": "Volver al inicio",
  "Review_Content": "Contenido de reseña",
  "add_To_Cart": "Agregar al carrito",
  "Read_reviews": "Leer reseñas",
  "Instruction1": "Instrucciones de cuidado",
  "Email_address": "Dirección de correo electrónico",
  "Category_Item_List": "Cambiar a vista de lista",
  "Same as shipping address": "Igual que la dirección de envío",
  "Category_Item_Grid": "Cambiar a vista de cuadrícula",
  "ID_Number_Error": "Ingrese su número de identificación",
  "concactus_label4": "Correo electrónico de contacto",
  "Additional_info": "Información adicional",
  "add_shipping": "Agregar una nueva dirección de envío",
  "Product_description": "El top Karissa V-Neck Tee tiene un diseño ajustado que se adapta a todo tipo de cuerpo. Se ajusta a sus curvas y oculta áreas problemáticas comunes para que pueda ejercitarse con confianza. También hay impresionantes vestidos de cóctel y vestidos de fiest",
  "Login_create_account": "Crear una cuenta",
  "after_sales_Reason": "Motivo del servicio postventa",
  "MyAccount_MyProfile_label_Last": "Apellido",
  "MyAccount_MyProfile_label2_pass2": "Nueva contraseña",
  "Save": "Guardar",
  "CartSliderTextBtn": "Guardar para comprar más tarde",
  "Color": "Color",
  "Shipping_Tax": "Impuesto sobre el envío",
  "Subscribe_to_success": "¡Te has suscrito!",
  "Enjoy your free account": "¡Disfruta de los beneficios de tu cuenta gratuita!",
  "cart_empty_desc": "Parece que aún no ha agregado ningún producto a su carrito. Empiece a comprar para llenarlo.",
  "MyAccount_ShippingDetails_message_title2": "Mantenga actualizada su dirección y detalles de contacto.",
  "An_error_occured": "Se produjo un error",
  "Country": "País",
  "MyAccount_MyShippingDetails_First": "Nombre",
  "payment_insurance_fee": "Tarifa de seguro",
  "Home": "Inicio",
  "Contact_us": "Contáctenos",
  "Cookies Policy": "Política de cookies",
  "Clear all": "Borrar todo",
  "Basket": "Cesta",
  "MyAccount_MyProfile_reqeatPassErrMsg": "La nueva contraseña no coincide",
  "Your current email address is": "Tu dirección de correo electrónico actual es",
  "You currently have no orders": "Actualmente no tienes pedidos",
  "Login_input_password": "Contraseña",
  "Promo_code": "Código de promoción",
  "order_count": "Número de pedidos",
  "email_geshi_error": "Ingrese una dirección de correo electrónico válida",
  "your_email": "Tu correo electrónico",
  "email": "Correo electrónico",
  "you_have_subscribed": "Te has suscrito",
  "cancel_Subscribe": "Cancelar suscripción",
  "save_and_pay": "Guardar y pagar",
  "hasInsurance": "¿Compraste un seguro?",
  "pleasePayType": "Por favor seleccione método de pago",
  "zhuanfa_toBePay": "Pagar a través de un amigo",
  "linkCopied": "Enlace copiado, ¡pegálo y compartilo con tus amigos!",
  "Links": "Enlaces",
  "article_category": "Categoría de artículos",
  "wechat_code_login_message": "Por favor, use WeChat para escanear el código QR e iniciar sesión",
  "wechat_code_login": "Iniciar sesión con el código QR de WeChat",
  "Api_Update_success": "Actualización exitosa",
  "Please_Use_WeChat_login": "Por favor, use WeChat para iniciar sesión",
  "mobile_geshi_error": "Ingrese un número de teléfono válido",
  "Login_input_email_required": "Ingrese su dirección de correo electrónico",
  "article_null": "No hay artículos disponibles",
  "Login_with_microsoft": "Inicio de sesión de Microsoft",
  "article_null_des": "Puede navegar por artículos de otras categorías",
  "register_email": "Registro de correo electrónico",
  "Login_tab_email": "Inicio de sesión con correo electrónico",
  "code.time": "Reintente después de {time} segundos",
  "Login_with_wechat": "Inicio de sesión de WeChat",
  "cat_items_null_des": "Puede navegar por productos de otras categorías",
  "Login_with_facebook": "Inicio de sesión de Facebook",
  "Login_input_code": "Código de verificación",
  "Login_input_mobile_required": "Ingrese su número de teléfono",
  "Login_input_mobile": "Su número de teléfono",
  "cat_items_null": "No hay productos disponibles en esta categoría",
  "Login_with_twitter": "Inicio de sesión de Twitter",
  "mobile_code": "Código de verificación",
  "register_mobile": "Registro de teléfono móvil",
  "Login_tab_mobile": "Inicio de sesión con teléfono móvil",
  "Login_with_google": "Inicio de sesión de Google",
  "OrderSku": "Especificación del producto",
  "Order_logisticsNo": "Número de seguimiento de la logística",
  "order_shopping_firstname": "Nombre",
  "Order_logisticsName": "Compañía de logística",
  "ItemPrice": "Monto del producto",
  "inPayOrderAll": "Lista de pagos pendientes",
  "payPrice": "Monto a pagar",
  "shipping_add_success": "La dirección de envío se ha creado correctamente",
  "match_goods": "productos populares",
  "pay_code_refresh": "Actualizar código de pago",
  "pay_code_shixiao": "El código de pago ha expirado",
  "concactus_title": "Contáctanos",
  "Search_items": "Buscar",
  "WebAutoLang": "Tu navegador actual recomienda el idioma:{lang}, ¿quieres cambiar a este idioma?",
  "Services_Name": "Nombre del servicio",
  "Services_Price": "Costo del servicio",
  "SwichLang": "Cambiar idioma",
  "Services_Description": "Descripción del servicio",
  "goodinfo_null": "No hay productos disponibles",
  "goodinfo_null_des": "Puede navegar por otros categorías de productos",
  "notYetUseCode": "Código de descuento no utilizado",
  "guest_Login": "Iniciar sesión como invitado",
  "billing_and_shipping": "Facturación y envío son iguales",
  "select_coupon": "Seleccione cupón",
  "select_gift": "Seleccione regalo",
  "currentUseCode": "Código de descuento utilizado",
  "shipping_refresh": "Actualizar lista",
  "Shipping_details": "Dirección de envío",
  "MyAccount_Newsletter": "Suscripción",
  "MyAccount_Profile": "Perfil",
  "MyAccount_Wishlist": "Lista de deseos",
  "See_all": "Todos",
  "MyAccount_History": "Historial de pedidos",
  "bind_microsoft": "Vincular Microsoft",
  "bind_twitter": "Vincular Twitter",
  "bind_facebook": "Vincular Facebook",
  "bind_wechat_code": "Código QR de WeChat",
  "bind_wechat": "Vincular WeChat",
  "bind_google": "Vincular Google",
  "Wishlist_Empty": "Sin lista de deseos",
  "discount_post_fee": "Descuento de envío",
  "ORDER_PART_PAID": "Pago parcial",
  "claimCouponeSuccess": "Obtener {name} éxito",
  "discount_kou": "{descuento} de descuento",
  "claimCoupone": "Obtener",
  "cartPreviewSafety_messageinfo": "Envío seguro y rápido a su dirección",
  "Order_No": "Número de orden",
  "cartPreviewSafety": "Entrega segura",
  "Shipping": "Envío",
  "MyAccount_MyShippingDetails_Street": "Calle",
  "MyAccount_MyShippingDetails_HouseNumber": "Número de casa",
  "Shipping_title": "Dirección de envío",
  "Offline_payment": "Pago sin conexión",
  "shopName": "Nombre de la tienda",
  "Social": "Redes sociales",
  "SERVICE": "Servicio",
  "onlineContact": "Contacto en línea",
  "confirm": "Confirmar",
  "closeOrder": "Cancelar pedido",
  "closeOrderContext": "¿Estás seguro de que quieres cancelar el pedido?",
  "Message_Read": "Leído",
  "close.order.success": "Pedido cancelado con éxito",
  "shippingAddress": "Dirección de envío",
  "Message": "Mensaje",
  "Message_Empty_Title": "Tu mensaje está vacío",
  "MyAccount_Message": "Mensaje",
  "Message_Empty": "No hay mensajes",
  "payment_order_note": "Nota del pedido",
  "go_to_see_prepid": "Haga clic aquí para ver sus órdenes no pagadas",
  "operate": "Operación",
  "removeCartItemContext": "¿Está seguro de que desea eliminar {title}？",
  "shippingItemQty": "Cantidad de envío",
  "removeCartItem": "Eliminar producto",
  "shippingInfo": "Información de envío",
  "Distributor_success": "Ya se ha convertido en distribuidor",
  "Distributor_apply": "Solicitud para convertirse en distribuidor",
  "Distributor_Details": "Distribuidor",
  "DistributorSataus": "Estado",
  "Distributor_Details_Empty": "No hay distribuidores por el momento",
  "distributor.status.4": "Anulado",
  "distributor.status.1": "No revisado",
  "Distributor_copy_url": "Copiar el enlace de distribución",
  "Order_Time": "Hora del pedido",
  "Order_User": "Ordenado por",
  "Distributor_copy_success": "Copiado con éxito",
  "distributor.status.3": "Compensado",
  "MyAccount_Distributor": "Distribuidor",
  "MyAccoubnt_Set_Distributor": "Solicitud para convertirse en distribuidor",
  "distributor.status.2": "Pendiente de compensación",
  "DistributorAmount": "Comisión",
  "Distributor_shenheshibai": "Distribuidor no aprobado",
  "Distributor_shenhezhong": "Distribuidor en revisión",
  "Distributor_Order_Empty": "Orden de distribuidor vacía",
  "NE": "Níger",
  "DJ": "Yibuti",
  "KP": "Corea del Norte",
  "US": "Estados Unidos",
  "LC": "Santa Lucía",
  "NL": "Países Bajos",
  "CD": "República Democrática del Congo",
  "IS": "Islandia",
  "MA": "Marruecos",
  "GH": "Ghana",
  "KR": "Corea del Sur",
  "MK": "Macedonia",
  "HT": "Haití",
  "PF": "Polinesia Francesa",
  "GA": "Gabón",
  "TD": "Chad",
  "LB": "Líbano",
  "CG": "Congo",
  "KG": "Kirguistán",
  "TA": "Tristán da Cunha",
  "KW": "Kuwait",
  "TL": "Timor Oriental",
  "IN": "India",
  "NO": "Noruega",
  "NG": "Nigeria",
  "AQ": "Antártida",
  "LY": "Libia",
  "NI": "Nicaragua",
  "TT": "Trinidad y Tobago",
  "HM": "Islas Heard y McDonald",
  "PY": "Paraguay",
  "BA": "Bosnia y Herzegovina",
  "JP": "Japón",
  "MD": "Moldavia",
  "MT": "Malta",
  "RE": "Reunión",
  "UG": "Uganda",
  "SB": "Islas Salomón",
  "SL": "Sierra Leone",
  "CV": "Cabo Verde",
  "SD": "Sudán",
  "FO": "Islas Feroe",
  "ZA": "Sudáfrica",
  "TR": "Turquía",
  "FK": "Islas Malvinas",
  "PA": "Panamá",
  "GF": "Guayana Francesa",
  "TJ": "Tayikistán",
  "NC": "Nueva Caledonia",
  "PM": "San Pedro y Miquelón",
  "NU": "Niue",
  "AO": "Angola",
  "VN": "Vietnam",
  "GN": "Guinea",
  "MW": "Malawi",
  "BY": "Bielorrusia",
  "IM": "Isla de Man",
  "BI": "Burundi",
  "BS": "Bahamas",
  "CK": "Islas Cook",
  "MH": "Islas Marshall",
  "CR": "Costa Rica",
  "HK": "Hong Kong, Región Administrativa Especial de China",
  "AD": "Andorra",
  "BN": "Brunei",
  "SN": "Senegal",
  "AE": "Emiratos Árabes Unidos",
  "GI": "Gibraltar",
  "CA": "Canadá",
  "AX": "Islas Åland",
  "UY": "Uruguay",
  "WF": "Wallis y Futuna",
  "GM": "Gambia",
  "SO": "Somalia",
  "RU": "Rusia",
  "PL": "Polonia",
  "FM": "Micronesia",
  "ET": "Etiopía",
  "EE": "Estonia",
  "SK": "Eslovaquia",
  "AS": "Samoa Americana",
  "ZM": "Zambia",
  "AL": "Albania",
  "AT": "Austria",
  "VA": "Ciudad del Vaticano",
  "TW": "Taiwán",
  "BD": "Bangladesh",
  "AR": "Argentina",
  "EH": "Sáhara Occidental",
  "MO": "Macao, Región Administrativa Especial de China",
  "MV": "Maldivas",
  "GU": "Guam",
  "AW": "Aruba",
  "AI": "Anguilla",
  "CL": "Chile",
  "IL": "Israel",
  "GD": "Granada",
  "WS": "Samoa",
  "SE": "Suecia",
  "GP": "Guadalupe",
  "YE": "Yemen",
  "GT": "Guatemala",
  "BG": "Bulgaria",
  "SJ": "Svalbard y Jan Mayen",
  "CO": "Colombia",
  "LS": "Lesoto",
  "LV": "Letonia",
  "UM": "Islas Ultramarinas Menores de Estados Unidos",
  "MX": "México",
  "DO": "República Dominicana",
  "PE": "Perú",
  "HN": "Honduras",
  "TC": "Islas Turcas y Caicos",
  "VI": "Islas Vírgenes, EE. UU.",
  "FJ": "Fiyi",
  "MP": "Islas Marianas del Norte",
  "AC": "Isla de la Ascensión",
  "NA": "Namibia",
  "SZ": "Swazilandia",
  "RW": "Ruanda",
  "BH": "Bahrein",
  "KN": "San Cristóbal y Nieves",
  "TN": "Túnez",
  "AF": "Afganistán",
  "VG": "Islas Vírgenes Británicas",
  "KE": "Kenia",
  "PK": "Pakistán",
  "GL": "Groenlandia",
  "SY": "Siria",
  "CU": "Cuba",
  "RS": "Serbia",
  "BF": "Burkina Faso",
  "BM": "Bermudas",
  "BZ": "Belice",
  "SV": "El Salvador",
  "CN": "China",
  "MF": "San Martín",
  "NF": "Isla Norfolk",
  "MZ": "Mozambique",
  "LU": "Luxemburgo",
  "TO": "Tonga",
  "GR": "Grecia",
  "SI": "Eslovenia",
  "PW": "Palaos",
  "TZ": "Tanzania",
  "IR": "Irán",
  "GG": "Guernsey",
  "SM": "San Marino",
  "TF": "Territorios Australes Franceses",
  "PS": "Palestina",
  "SC": "Seychelles",
  "BT": "Bután",
  "JM": "Jamaica",
  "BR": "Brasil",
  "CH": "Suiza",
  "SH": "Santa Elena",
  "HU": "Hungría",
  "TM": "Turkmenistán",
  "LT": "Lituania",
  "MC": "Mónaco",
  "LI": "Liechtenstein",
  "LR": "Liberia",
  "GE": "Georgia",
  "SA": "Arabia Saudita",
  "GB": "Reino Unido",
  "VE": "Venezuela",
  "MU": "Mauricio",
  "HR": "Croacia",
  "SR": "Surinam",
  "CM": "Camerún",
  "IQ": "Irak",
  "BO": "Bolivia",
  "MN": "Mongolia",
  "DZ": "Argelia",
  "TK": "Tokelau",
  "MG": "Madagascar",
  "YT": "Mayotte",
  "CC": "Islas Cocos",
  "LA": "Laos",
  "PT": "Portugal",
  "QA": "Qatar",
  "AN": "Antillas Holandesas",
  "PN": "Isla Pitcairn",
  "ES": "España",
  "VC": "San Vicente y Grenadinas",
  "AU": "Australia",
  "CX": "Isla de Navidad",
  "KM": "Comoras",
  "MR": "Mauritania",
  "FR": "Francia",
  "SG": "Singapur",
  "BV": "Isla Bouvet",
  "PH": "Filipinas",
  "CY": "Chipre",
  "TV": "Tuvalu",
  "CF": "República Centroafricana",
  "EC": "Ecuador",
  "GW": "Guinea-Bissau",
  "IE": "Irlanda",
  "LK": "Sri Lanka",
  "ER": "Eritrea",
  "GQ": "Guinea Ecuatorial",
  "NP": "Nepal",
  "BE": "Bélgica",
  "GY": "Guyana",
  "DK": "Dinamarca",
  "MQ": "Martinica",
  "UZ": "Uzbekistán",
  "CI": "Costa de Marfil",
  "ID": "Indonesia",
  "BJ": "Benin",
  "ST": "Santo Tomé y Príncipe",
  "KH": "Camboya",
  "KZ": "Kazajstán",
  "MS": "Montserrat",
  "TH": "Tailandia",
  "FI": "Finlandia",
  "ML": "Malí",
  "AM": "Armenia",
  "IT": "Italia",
  "NR": "Nauru",
  "PG": "Papúa Nueva Guinea",
  "ZW": "Zimbabue",
  "JO": "Jordania",
  "OM": "Omán",
  "ME": "Montenegro",
  "JE": "Jersey",
  "NZ": "Nueva Zelanda",
  "VU": "Vanuatu",
  "DE": "Alemania",
  "CZ": "República Checa",
  "DM": "Dominica",
  "KY": "Islas Caimán",
  "BW": "Botswana",
  "RO": "Rumania",
  "PR": "Puerto Rico",
  "AZ": "Azerbaiyán",
  "IO": "Territorio Británico del Océano Índico",
  "UA": "Ucrania",
  "TG": "Togo",
  "MY": "Malasia",
  "AG": "Antigua y Barbuda",
  "EG": "Egipto",
  "GS": "Islas Georgias del Sur y Sandwich del Sur",
  "MM": "Myanmar",
  "BB": "Barbados",
  "KI": "Kiribati",
  "All_Country": "Todos",
  "post_state_country": "Precio de envío: {country} {state} {postFee}",
  "zhichiDeliveryCountry": "Entrega a",
  "ShippingFee": "Tarifa de envío",
  "reviewOutOf": "{rating} estrellas, de 5",
  "product.pifa.label": "Compre {startnum} - {endnum} unidades",
  "product.pifa.type.1": "Descuento",
  "Write_a_review": "Escribir una reseña",
  "BasedOnTotalReviews": "Basado en {total} reseñas",
  "product.wholesale": "Precio al por mayor",
  "reviewMostRecent": "Reseñas más recientes",
  "product.pifa.type.2": "Precio unitario",
  "product.num.danwei": "unidad",
  "good.shoppingDateLabel": "Fecha de envío",
  "good.shippingPeriod": "Envío dentro de días",
  "emailError": "Formato de correo electrónico incorrecto",
  "addressNote": "Nota de dirección",
  "Concactus": "Contacto",
  "addressMessage": "Asegúrese de que su dirección sea correcta. Después de hacer el pedido, no podremos cambiar la dirección.",
  "showOrderSummary": "Resumen del pedido",
  "payment_method": "Método de pago",
  "emailNotNullError": "El correo electrónico no puede estar vacío",
  "orderCreateLoading": "Creando pedido...",
  "emailNote": "Contacto",
  "emailMessage": "Asegúrese de que su dirección de correo electrónico sea correcta. Le enviaremos un correo electrónico de confirmación de pedido.",
  "payment_method_message": "Todas las transacciones son seguras y encriptadas.",
  "go_buy_goods": "Continuar comprando",
  "tap_cancel_order": "Haga clic aquí para cancelar el pedido",
  "order_review": "evaluación del pedido",
  "Add_new_address": "Agregar nueva dirección",
  "promo_code_type_3": "Cupón de regalo",
  "IdCardNotNull": "Por favor, complete la información de identidad real",
  "UploadVideo": "Subir video",
  "video": "Vídeo",
  "UploadImage": "Subir imagen",
  "uploadImageing": "Subiendo...",
  "BillingInfoNotNull": "Información de la factura incompleta",
  "promo_code_type_2": "Cupón de descuento",
  "UploadError": "Error al subir",
  "promo_code_type_4": "Cupón de reducción de flete",
  "image": "Imagen",
  "paymentMethodNotNull": "Por favor seleccione un método de pago",
  "promo_code_type_1": "Cupón de descuento porcentual",
  "shippingInfoNotNull": "Información de envío incompleta",
  "reviewDetail": "Detalles de la evaluación",
  "DeliveryCountry": "Área de Entrega",
  "prompt_error": "Error de advertencia",
  "save_review_success": "Éxito en la evaluación",
  "ORDER_COMPLETED": "completado",
  "crate_after_sales": "crear servicio posventa",
  "Thank_You_Order": "¡Gracias por su orden!",
  "Thank_You_Order_sub": "Pronto comenzaremos a procesar su pedido. Recibirá un correo electrónico con información sobre el proceso del pedido.",
  "BootomCookieContext": "Este sitio web utiliza cookies para ayudar al sitio web a funcionar correctamente y para ayudarnos a comprender cómo interactúa con él. Utilizamos estas cookies para proporcionarle una mejor experiencia de usuario personalizada. Si continúa utilizando est",
  "order_reivice_message": "¿Estás seguro de que ya has recibido la mercancía?",
  "order_reivice_btn": "Confirmar recepción",
  "order_reivice_label": "Recepción del pedido",
  "order_reivice_success": "La recepción del pedido se ha confirmado correctamente",
  "collpase_show": "Ver más",
  "collpase_hide": "Replegar",
  "CouponCode": "Código de cupón",
  "wechatPayScannerCode": "Por favor use WeChat para escanear el código de pago",
  "processing": "Procesando el servicio postventa",
  "finished": "Servicio postventa completado",
  "login.showPrice": "Inicia sesión para ver el precio",
  "After_Sales_Unknown": "Estado del servicio postventa desconocido",
  "order_payment_list_null": "No hay órdenes pendientes de pago",
  "Cancel": "Cancelar",
  "thankyou_concat": "Si tiene alguna pregunta, por favor contáctenos"
}